<template>
    <div>
        <img src="img/noResult.png">
        <div v-if="searchContent || param.updateTimeStart">
            <div>没有找到对应的作品</div>
            <el-button type="primary" @click="getAllData" round>查看全部</el-button>
        </div>
        <div v-else>
            <div>您还没有作品</div>
            <div>请到<router-link to="/template">模板库</router-link>选择模板，并生成作品</div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        searchContent: String,
        param: Object,
    },
    methods: {
        getAllData () {
            this.$emit('getAllData');
        }
    }
}
</script>

